const MEGABYTE = 1024 * 1024;

export const UPLOAD_MAX_SIZE = 5 * MEGABYTE;

export const PHOTO_MIME_TYPES = ["image/jpeg", "image/png", "image/gif", "image/webp"];

export const PHOTO_ACCEPT_ATTRIBUTE = PHOTO_MIME_TYPES.join(",");

export const UPLOAD_MAX_SIZE_LABEL = `${UPLOAD_MAX_SIZE / MEGABYTE}MB`;

export function validateUpload(file, allowedMimeTypes = null) {
  if (allowedMimeTypes && !allowedMimeTypes.includes(file.type)) {
    return {
      valid: false,
      reason: `O arquivo "${file.name}" tem um tipo (${file.type || "desconhecido"}) que não é aceito neste campo.`,
    };
  }

  if (file.size > UPLOAD_MAX_SIZE) {
    return {
      valid: false,
      reason: `O arquivo "${file.name}" excede o tamanho máximo permitido (${UPLOAD_MAX_SIZE_LABEL}).`,
    };
  }

  return { valid: true };
}

export function readUploadAsBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      resolve({
        name: file.name,
        mime: file.type,
        base64File: event.target.result,
      });
    };

    reader.onerror = () => reject(reader.error);

    reader.readAsDataURL(file);
  });
}
